module.exports = __webpack_public_path__ + "img/nothing.2ce1c7c1.png";